import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import * as XLSX from "xlsx";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import '../App.css';
import { mediaURL } from "./api";
import { mdiCheckCircle, mdiCloseCircle, mdiFileExcel, mdiFilePdfBox } from '@mdi/js';
import Icon from '@mdi/react';
import Membershippaymentsmodal from "../pages/membershippaymentsmodal";

export const PaginatedTable = ({
    columns,
    data,
    onEdit,
    onDelete,
    onView,
    defaultPageSize = 5,
    showedit = true,
    showstatus = true,
    showdelete = false,
    showdownload = true,
    showopenregistrations = false,
    openRegistrations,
    showpayments=false,
    showuseredit=false,
}) => {
    const [searchTerm, setSearchTerm] = useState("");
    const [pageNumber, setPageNumber] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(defaultPageSize);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    const filteredData = data.filter((item) =>
        Object.values(item).some(
            (val) => val && val.toString().toLowerCase().includes(searchTerm.toLowerCase())
        )   
    );

    const pagesVisited = pageNumber * itemsPerPage;
    const displayData = filteredData.slice(pagesVisited, pagesVisited + itemsPerPage);
    const pageCount = Math.ceil(filteredData.length / itemsPerPage);
    const handlePageChange = ({ selected }) => setPageNumber(selected);

    const exportToExcel = () => {
        try {
          const filteredExportData = filteredData.map(({ id, image, status, ...rest }) => rest);
          const ws = XLSX.utils.json_to_sheet(filteredExportData);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          XLSX.writeFile(wb, "output.xlsx");
        } catch (error) {
          console.error("Error exporting to Excel:", error);
          alert("An error occurred while exporting data. Please try again.");
        }
      };
      
      const exportToPDF = () => {
        try {
          const doc = new jsPDF({ orientation: "landscape" });
          const filteredColumns = columns.filter((col) => !["id", "image", "status"].includes(col));
          const tableData = filteredData.map((row) =>
            filteredColumns.map((col) => row[col] || "N/A")
          );
      
          autoTable(doc, {
            head: [filteredColumns],
            body: tableData,
            startY: 20,
            theme: "grid",
            styles: { fontSize: 10 },
          });
      
          doc.save("output.pdf");
        } catch (error) {
          console.error("Error exporting to PDF:", error);
          alert("An error occurred while exporting to PDF. Please try again.");
        }
      };
      

      const formatDate = (value) => {
        try {
          if (value) {
            const date = new Date(value);
            if (isNaN(date)) return value;
      
            const pad = (n) => n.toString().padStart(2, '0');
      
            // Return date in MM-DD-YYYY format
            return `${pad(date.getMonth() + 1)}-${pad(date.getDate())}-${date.getFullYear()}`;
          } else {
            return value;
          }
        } catch (error) {
          console.error("Error formatting date:", error);
          return value;
        }
      };
      

      const addpayment = (item) => {
        try {
          setSelected(item);
          setIsModalOpen(true);
        } catch (error) {
          console.error("Error in addpayment:", error);
        }
      };
      

    return (
        <>
            <div className="search-container d-flex justify-content-between align-items-center mb-3" style={{ fontSize: "12px" }}>
                <input
                    type="text"
                    placeholder="Search..."
                    value={searchTerm}
                    style={{ width: "80%" }}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
                <select
                    value={itemsPerPage}
                    onChange={(e) => {
                        setItemsPerPage(Number(e.target.value));
                        setPageNumber(0);
                    }}
                >
                    {[1, 5, 10, 20, 50, 100, 500, 1000].map((n) => (
                        <option key={n} value={n}>{n} per page</option>
                    ))}
                </select>
            </div>

            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr style={{ background: "#f06969" }}>
                            {columns.map((col, index) => {
                                if (col === 'status' && showstatus) return null;
                                return <th key={index}>{col.toUpperCase()}</th>;
                            })}
                            {(localStorage.getItem('role')=='admin') && showstatus  && <th>STATUS</th>}
                            {(localStorage.getItem('role') == 'admin' && showedit || showdelete) && <th style={{ width: '200px' }}>ACTION</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {displayData.length > 0 ? (
                            displayData.map((item, index) => (
                                <tr key={index}>
                                    {columns.map((col, colIndex) => {
                                        if (col === 'status' && showstatus) return null;

                                        if (col === 'image') {
                                            return (
                                                <td key={colIndex}>
                                                    {item[col] ? (
                                                        <img
                                                            src={mediaURL + item[col]}
                                                            alt="Preview"
                                                            style={{ width: "50px", height: "50px", borderRadius: "5px" }}
                                                        />
                                                    ) : "N/A"}
                                                </td>
                                            );
                                        }

                                        if (col.toLowerCase().includes("date")) {
                                            return (
                                                <td key={colIndex}>{(item[col])}</td>
                                            );
                                        }

                                        if (col.toLowerCase() === "role") {
                                            const role = item[col]?.toLowerCase();
                                            return (
                                                <td key={colIndex}>
                                                    {role === "admin" && <span className="badge bg-danger">Admin</span>}
                                                    {role === "user" && <span className="badge bg-primary">User</span>}
                                                    {!["admin", "user"].includes(role) && item[col]}
                                                </td>
                                            );
                                        }

                                        if (col.toLowerCase() === "registrationallowed") {
                                            const registrationallowed = item[col]?.toLowerCase();
                                            return (
                                                <td key={colIndex}>
                                                    {registrationallowed === "0" && <span className="badge bg-danger">No</span>}
                                                    {registrationallowed === "1" && <span className="badge bg-primary">Yes</span>}
                                                    {!["0", "1"].includes(registrationallowed) && item[col]}
                                                </td>
                                            );
                                        }

                                        return <td key={colIndex}>{item[col] || "N/A"}</td>;
                                    })}
                                    {(localStorage.getItem('role')=='admin') && showstatus && (
                                        <td>
                                            {item?.status === '1' ? (
                                                <span className="badge bg-success">Active</span>
                                            ) : item?.status === '0' ? (
                                                <span className="badge bg-danger">Inactive</span>
                                            ) : "N/A"}
                                        </td>
                                    )}
                                    {(showuseredit) && (
                                          <div className="d-flex flex-wrap align-items-center gap-2">
                                              { (localStorage.getItem('role')=='user') && showuseredit && (
                                                    <button className="btn btn-primary btn-sm" style={{ fontSize: "10px" }} onClick={() => onEdit(item)}>
                                                        Edit
                                                    </button>
                                                )}
                                          </div>
                                    )
                                    }
                                    {(showedit || showdelete) && (
                                        <td>
                                            <div>

                                            </div>

                                            <div className="d-flex flex-wrap align-items-center gap-2">
                                                { (localStorage.getItem('role')=='admin') && showedit && (
                                                    <button className="btn btn-primary btn-sm" style={{ fontSize: "10px" }} onClick={() => onEdit(item)}>
                                                        Edit
                                                    </button>
                                                )}
                                                {showdelete && (
                                                    <button className="btn btn-danger btn-sm" style={{ fontSize: "10px" }} onClick={() => onDelete(item)}>
                                                        Delete
                                                    </button>
                                                )}
                                                {showopenregistrations && (
                                                    <button className="btn btn-info btn-sm" style={{ fontSize: "10px" }} onClick={() => openRegistrations(item)}>
                                                        Registrations
                                                    </button>
                                                )}
                                                {showpayments && (
                                                    <button className="btn btn-success btn-sm" style={{ fontSize: "10px" }} onClick={() => addpayment(item)}>
                                                        Payment
                                                    </button>
                                                )}
                                            </div>

                                        </td>
                                    )}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns.length + 4} className="text-center">No data found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            <div className="footer-container d-flex justify-content-between align-items-center mt-3">
                <div>
                    {showdownload && (
                        <>
                            <button className="btn btn-warning btn-sm me-2" style={{ fontSize: "10px" }} onClick={exportToExcel}>
                                <Icon path={mdiFileExcel} size={0.5} className="me-1" />
                                Excel
                            </button>
                            <button className="btn btn-info btn-sm" style={{ fontSize: "10px" }} onClick={exportToPDF}>
                                <Icon path={mdiFilePdfBox} size={0.5} className="me-1" />
                                PDF
                            </button>
                        </>
                    )}

                </div>
                <div className="pagination" style={{ height: "50px", fontSize: "12px" }}>
                    <ReactPaginate
                        previousLabel={"Prev"}
                        nextLabel={"Next"}
                        pageCount={pageCount}
                        onPageChange={handlePageChange}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        activeClassName={"active"}
                        style={{ fontSize: "12px" }}
                    />
                </div>
                <Membershippaymentsmodal
                    isModalOpen={isModalOpen}
                    setIsModalOpen={setIsModalOpen}
                    selected={selected}
                />
            </div>
        </>
    );
};

export default PaginatedTable;
